module.exports = __webpack_public_path__ + "static/media/l28_thumb_even.e8984c92.webp";